import StudentIcon from 'src/images/svg/StudentIcon';
import {
  DashboardIcon,
  LoanIcon,
  StreetCentsIcon,
  BadgeIcon,
  FinancialSimulationsIcon,
  StreetCredIcon,
  ClassIcon,
  SettingsIcon,
  TeacherIcon,
} from 'src/images/svg';
import { MdOutlinePendingActions, MdOutlinePayments, MdOutlineGroups, MdOutlineAdminPanelSettings } from 'react-icons/md';
import { FaGoogleWallet, FaFileInvoiceDollar } from 'react-icons/fa';
import { JSX } from 'react';
import { PermissionKey } from 'src/types/permissions.types';

interface NavItem {
  title: string;
  path: string;
  icon: JSX.Element;
  activeIcon: JSX.Element;
  paths: string[];
  /** Required to see this item. Items with no permission are always shown. */
  permission?: PermissionKey;
}

type NavConfig = NavItem[];

export const teacherNavConfig: NavConfig = [
  {
    title: 'Dashboard',
    path: '/teacher/dashboard',
    icon: <DashboardIcon color="#718096" />,
    activeIcon: <DashboardIcon color="#EDB42E" />,
    paths: ['/teacher/dashboard'],
  },
  {
    title: 'Transaction Management',
    path: '/teacher/transaction-management',
    permission: 'transactions.create',
    icon: <LoanIcon color="#718096" />,
    activeIcon: <LoanIcon color="#EDB42E" />,
    paths: ['/teacher/transaction-management'],
  },
  {
    title: 'Students',
    path: '/teacher/students',
    permission: 'students.view_assigned',
    icon: <StudentIcon color="#718096" />,
    activeIcon: <StudentIcon color="#EDB42E" />,
    paths: ['/teacher/students', '/teacher/add-student', '/teacher/edit-student', '/teacher/student/:studntId', '/teacher/view-student/:studentId'],
  },
  {
    title: 'Loan Requests',
    path: '/teacher/loan-requests',
    permission: 'loans.approve',
    icon: <LoanIcon color="#718096" />,
    activeIcon: <LoanIcon color="#EDB42E" />,
    paths: ['/teacher/loan-requests', '/teacher/view-loan/:loanId'],
  },
  {
    title: 'S.T.R.E.E.T Cents',
    path: '/teacher/street-cents',
    permission: 'transactions.view_assigned',
    icon: <StreetCentsIcon color="#718096" />,
    activeIcon: <StreetCentsIcon color="#EDB42E" />,
    paths: ['/teacher/street-cents'],
  },
  {
    title: 'Badges',
    path: '/teacher/badges',
    icon: <BadgeIcon color="#718096" />,
    activeIcon: <BadgeIcon color="#EDB42E" />,
    paths: ['/teacher/badges', '/teacher/add-new-badge', '/teacher/edit-badge/:badgeId'],
  },
  {
    title: 'Whammies',
    path: '/teacher/financial-simulations',
    permission: 'whammies.view_assigned',
    icon: <FinancialSimulationsIcon color="#718096" />,
    activeIcon: <FinancialSimulationsIcon color="#EDB42E" />,
    paths: [
      '/teacher/financial-simulations',
      '/teacher/assign-new-chellenge',
      '/teacher/view-financial-simulations/:id',
    ],
  },
  {
    title: 'S.T.R.E.E.T Cred',
    path: '/teacher/street-cred',
    permission: 'street_cred.view_assigned',
    icon: <StreetCredIcon color="#718096" />,
    activeIcon: <StreetCredIcon color="#EDB42E" />,
    paths: ['/teacher/street-cred', '/teacher/add-student-behaviour'],
  },
  {
    title: 'Cohorts',
    path: '/teacher/cohorts',
    permission: 'cohorts.view_assigned',
    icon: <MdOutlineGroups size={20} color="#718096" />,
    activeIcon: <MdOutlineGroups size={20} color="#EDB42E" />,
    paths: ['/teacher/cohorts', '/teacher/cohorts/:cohortId'],
  },
  {
    title: 'Settings',
    path: '/teacher/edit-profile',
    icon: <SettingsIcon color="#718096" />,
    activeIcon: <SettingsIcon color="#EDB42E" />,
    paths: ['/teacher/edit-profile', '/teacher/change-password'],
  },
];

export const studentNavConfig: NavConfig = [
  {
    title: 'Dashboard',
    path: '/student/dashboard',
    icon: <DashboardIcon color="#718096" />,
    activeIcon: <DashboardIcon color="#EDB42E" />,
    paths: ['/student/dashboard'],
  },
  {
    title: 'Pay Bills',
    path: '/student/bills',
    icon: <MdOutlinePayments size={20} color="#718096" />,
    activeIcon: <MdOutlinePayments size={20} color="#EDB42E" />,
    paths: ['/student/bills'],
  },
  {
    title: 'S.T.R.E.E.T Cents',
    path: '/student/street-cents',
    permission: 'transactions.view_self',
    icon: <StreetCentsIcon color="#718096" />,
    activeIcon: <StreetCentsIcon color="#EDB42E" />,
    paths: ['/student/street-cents'],
  },
  {
    title: 'Paychecks',
    path: '/student/paychecks',
    icon: <FaFileInvoiceDollar color="#718096" size={18} />,
    activeIcon: <FaFileInvoiceDollar color="#EDB42E" size={18} />,
    paths: ['/student/paychecks'],
  },
  {
    title: 'Auto Rules & Savings',
    path: '/student/financial-tools',
    icon: <FaGoogleWallet color="#718096" />,
    activeIcon: <FaGoogleWallet color="#EDB42E" />,
    paths: ['/student/financial-tools'],
  },
  {
    title: 'Request Loan',
    path: '/student/loan-requests',
    icon: <LoanIcon color="#718096" />,
    activeIcon: <LoanIcon color="#EDB42E" />,
    paths: [
      '/student/loan-requests',
      '/student/new-loan-request',
      '/student/new-loan-request/:id',
      '/student/view-loan/:id',
      '/student/view-loan/:loanId',
      '/student/loan-requests/:id',
    ],
  },
  {
    title: 'S.T.R.E.E.T Cred',
    path: '/student/street-cred',
    permission: 'street_cred.view_self',
    icon: <StreetCredIcon color="#718096" />,
    activeIcon: <StreetCredIcon color="#EDB42E" />,
    paths: ['/student/street-cred', '/student/add-student-behaviour'],
  },
  {
    title: 'Whammies',
    path: '/student/financial-simulations',
    permission: 'whammies.view_assigned',
    icon: <FinancialSimulationsIcon color="#718096" />,
    activeIcon: <FinancialSimulationsIcon color="#EDB42E" />,
    paths: ['/student/financial-simulations', '/student/view-financial-simulations/:id'],
  },
  {
    title: 'Settings',
    path: '/student/edit-profile',
    icon: <SettingsIcon color="#718096" />,
    activeIcon: <SettingsIcon color="#EDB42E" />,
    paths: ['/student/edit-profile', '/student/change-password'],
  },
];

export const adminNavConfig: NavConfig = [
  {
    title: 'Dashboard',
    path: '/admin/dashboard',
    icon: <DashboardIcon color="#718096" />,
    activeIcon: <DashboardIcon color="#EDB42E" />,
    paths: ['/admin/dashboard'],
  },
  {
    title: 'Students',
    path: '/admin/students',
    permission: 'students.view_all',
    icon: <StudentIcon color="#718096" />,
    activeIcon: <StudentIcon color="#EDB42E" />,
    paths: ['/admin/students', '/admin/add-student', '/admin/edit-student/:studentId', '/admin/view-student/:studntId', '/admin/view-student/:studentId'],
  },
  {
    title: 'Loan Requests',
    path: '/admin/loan-requests',
    permission: 'loans.approve',
    icon: <LoanIcon color="#718096" />,
    activeIcon: <LoanIcon color="#EDB42E" />,
    paths: ['/admin/loan-requests', '/admin/view-loan/:loanId'],
  },
  {
    title: 'S.T.R.E.E.T Cents',
    path: '/admin/manage-transaction-types',
    permission: 'transaction_types.manage',
    icon: <StreetCentsIcon color="#718096" />,
    activeIcon: <StreetCentsIcon color="#EDB42E" />,
    paths: [
      '/admin/manage-transaction-types',
      '/admin/add-transaction-type',
      '/admin/edit-transaction-type/:transactionTypeId',
    ],
  },
  {
    title: 'Scholar Dollar Pay',
    path: '/admin/payroll',
    permission: 'payroll.access',
    icon: <MdOutlinePayments size={20} color="#718096" />,
    activeIcon: <MdOutlinePayments size={20} color="#EDB42E" />,
    paths: [
      '/admin/payroll',
      '/admin/payroll/import',
      '/admin/payroll/imports',
      '/admin/payroll/roster',
      '/admin/payroll/tax-day',
    ],
  },
  {
    title: 'Transactions Tracker',
    path: '/admin/transaction-status-tracker',
    permission: 'transactions.view_all',
    icon: <MdOutlinePendingActions size={20} color="#718096" />,
    activeIcon: <MdOutlinePendingActions size={20} color="#EDB42E" />,
    paths: ['/admin/transaction-status-tracker'],
  },
  {
    title: 'Badges',
    path: '/admin/badges',
    icon: <BadgeIcon color="#718096" />,
    activeIcon: <BadgeIcon color="#EDB42E" />,
    paths: ['/admin/badges', '/admin/add-new-badge', '/admin/edit-badge/:badgeId'],
  },
  {
    title: 'Whammies',
    path: '/admin/financial-simulations',
    permission: 'whammies.view_all',
    icon: <FinancialSimulationsIcon color="#718096" />,
    activeIcon: <FinancialSimulationsIcon color="#EDB42E" />,
    paths: [
      '/admin/financial-simulations',
      '/admin/add-scenario',
      '/admin/edit-scenario/:scenarioId',
      '/admin/assign-new-chellenge',
      '/admin/view-financial-simulations/:id',
    ],
  },
  {
    title: 'S.T.R.E.E.T Cred',
    path: '/admin/street-cred',
    permission: 'street_cred.view_all',
    icon: <StreetCredIcon color="#718096" />,
    activeIcon: <StreetCredIcon color="#EDB42E" />,
    paths: [
      '/admin/street-cred',
      '/admin/add-behavior-type',
      '/admin/edit-behaviour-type/:behaviourId',
      '/admin/add-student-behaviour',
    ],
  },
  {
    title: 'Teachers',
    path: '/admin/teachers',
    permission: 'teachers.view_all',
    icon: <TeacherIcon color="#718096" />,
    activeIcon: <TeacherIcon color="#EDB42E" />,
    paths: ['/admin/teachers', '/admin/add-new-teacher', '/admin/edit-teacher/:teacherId', '/admin/view-teacher/:teacherId'],
  },
  // {
  //   title: 'Classes',
  //   path: '/admin/classes',
  //   icon: <ClassIcon color="#718096" />,
  //   activeIcon: <ClassIcon color="#EDB42E" />,
  //   paths: ['/admin/classes', '/admin/add-new-class', '/admin/add-students'],
  // },
  {
    title: 'Cohorts',
    path: '/admin/cohorts',
    permission: 'cohorts.view_all',
    icon: <MdOutlineGroups size={20} color="#718096" />,
    activeIcon: <MdOutlineGroups size={20} color="#EDB42E" />,
    paths: ['/admin/cohorts', '/admin/cohorts/:cohortId'],
  },
  {
    title: 'Roles',
    path: '/admin/roles',
    permission: 'roles.manage',
    icon: <MdOutlineAdminPanelSettings size={20} color="#718096" />,
    activeIcon: <MdOutlineAdminPanelSettings size={20} color="#EDB42E" />,
    paths: ['/admin/roles', '/admin/roles/:roleName'],
  },
  {
    title: 'Settings',
    path: '/admin/edit-profile',
    icon: <SettingsIcon color="#718096" />,
    activeIcon: <SettingsIcon color="#EDB42E" />,
    paths: ['/admin/edit-profile', '/admin/change-password'],
  },
];

/** Keeps only the navigation items the current user may see. */
export function filterNavByPermission(
  items: NavConfig,
  hasPermission: (permission: PermissionKey) => boolean
): NavConfig {
  return items.filter((item) => !item.permission || hasPermission(item.permission));
}
